export class AppointmentVisitDataViewModel {
    SectionId?: number;
    DoctorId?: number;
    AppointmentDate: Date;
    constructor() {
    }
}

